export default __webpack_public_path__ + "tmp_src/components/Collection/CollectionSorting~nova.css.liquid";